import { createContext, useContext, useState } from 'react';

const GoalContext = createContext();

export const mockGoal = {
  id: 1,
  name: 'Trip to Japan',
  amount: 6000,
  currentSaved: 1240,
  deadline: '2027-12-01',
  accountId: 1,
  contributions: [
    { date: '2026-03-01', amount: 250 },
    { date: '2026-04-01', amount: 250 },
    { date: '2026-05-01', amount: 350 },
    { date: '2026-06-01', amount: 390 },
  ]
};

export const GoalProvider = ({ children }) => {
  const [goal, setGoal] = useState({
    name: '',
    amount: 0,
    deadline: '',
    accountId: null,
    currentSaved: 0
  });

  const [savedGoals, setSavedGoals] = useState([mockGoal]);

  const saveGoal = (newGoal) => {
    const goalWithId = { ...newGoal, id: Date.now(), currentSaved: 0, contributions: [] };
    setSavedGoals(prev => [...prev, goalWithId]);
    return goalWithId;
  };

  const updateGoal = (id, updates) => {
    setSavedGoals(prev => prev.map(g => g.id === id ? { ...g, ...updates } : g));
  };

  const addMoney = (id, amount) => {
    const today = new Date().toISOString().split('T')[0];
    setSavedGoals(prev => prev.map(g => {
      if (g.id !== id) return g;
      return {
        ...g,
        currentSaved: g.currentSaved + amount,
        contributions: [...(g.contributions || []), { date: today, amount }]
      };
    }));
  };

  const deleteGoal = (id) => {
    setSavedGoals(prev => prev.filter(g => g.id !== id));
  };

  const getGoal = (id) => {
    return savedGoals.find(g => g.id === parseInt(id)) || null;
  };

  return (
    <GoalContext.Provider value={{ goal, setGoal, savedGoals, saveGoal, updateGoal, deleteGoal, getGoal, addMoney }}>
      {children}
    </GoalContext.Provider>
  );
};

export const useGoal = () => {
  const ctx = useContext(GoalContext);
  if (!ctx) throw new Error('useGoal must be used within GoalProvider');
  return ctx;
};
